/*
    Optimizations to deal with the massive moment libraries
    Generally the idea is to only include the data we need,
    which may vary by the user (e.g. A .com user does not need to have all the non-en_US locale data)
    Also take a look at the Webpack config to see how we separate out the data.
    Links:
    https://medium.com/@michalozogan/how-to-split-moment-js-locales-to-chunks-with-webpack-de9e25caccea
    https://momentjs.com/timezone/docs/#/use-it/webpack/
*/

const genericDynamicImportErrorHandler = (err) => {
    if (process.env.NODE_ENV !== 'production') {
        throw err;
    }
    return null;
};

if (typeof window === 'object') {
    if (window.__i18n__ && window.__i18n__.locale === 'en_US') {
        // The idea here is to import moment and moment-tz by themselves, to split them out on their own,
        // otherwise they will be included in much larger bundles. Generally we aim to get each bundle <50 KB
        // Moment comes with en_US by default so US users don't need any extra data
        import('@eb/date').catch(genericDynamicImportErrorHandler);
        import('moment-timezone').catch(genericDynamicImportErrorHandler);
    } else {
        // In webpack we take out the locales to avoid forcing them on all users
        // TODO: If this results in a decent performance gain, we should configure it so that
        // other big locales like DE, AR, UK, etc can import only the locale they need
        import('./init-moment-locales')
            .then(() => {
                import('@eb/date').catch(genericDynamicImportErrorHandler);
                import('moment-timezone').catch(
                    genericDynamicImportErrorHandler,
                );
            })
            .catch(genericDynamicImportErrorHandler);
    }
}
